import React, { useState } from 'react';
import { Product } from './Catalogue';
import { useTranslation } from 'react-i18next';
import PreviewProfileItem from '../../PreviewProfileItem';
import DeleteModal from '../../../atoms/DeleteModal';
import CustomModal from '../../../atoms/CustomModal';
import CatalogueForm from './CatalogueForm';
import { useDeleteCatalogueMutation } from '../../../../store/services/sellerProfileCreationService';
import { message } from 'antd';

export default function ItemsList({
  data,
  profileId,
  refetchCatalogues,
}: {
  data: Product[];
  profileId: string;
  refetchCatalogues: () => void;
}) {
  const { t } = useTranslation();

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState<Product | null>(null);

  const [deleteCatalogue, { isLoading }] = useDeleteCatalogueMutation();

  const handleDelete = async () => {
    if (deleteId) {
      try {
        await deleteCatalogue({ profileId, catalogueId: deleteId });
        refetchCatalogues();
        setDeleteModalOpen(false);
      } catch (err) {
        message.error(t('components.somethingWentWrong'));
      }
    }
  };

  return (
    <div className="max-h-[600px] overflow-auto space-y-5 hidden-scrollbar" data-testid="catalogue-items-list">
      {data?.map((product) => {
        const formattedAttachments = product.attachments?.map((a) => ({
          ...a,
          type: a.type || 'IMAGE', // Fallback
        })) || [];

        return (
          <PreviewProfileItem
            key={product.id}
            itemId={product.id}
            title={product.name}
            description={product.description}
            specs={product.specs}
            catalogueMode
            isEditable
            isDelete
            attachments={formattedAttachments}
            onEdit={() => {
              setEditData(product);
              setEditModalOpen(true);
            }}
            onDelete={() => {
              setDeleteId(product.id);
              setDeleteModalOpen(true);
            }}
          />
        );
      })}

      <DeleteModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onDelete={handleDelete}
        isLoading={isLoading}
        title={t('components.deleteCatalogueTitle')}
        description={t('components.deleteCatalogueDescription')}
      />

      <CustomModal
        open={editModalOpen}
        onCancel={() => setEditModalOpen(false)}
        title={t('components.edit_catalogue')}
      >
        {editModalOpen && (
          <CatalogueForm
            profileId={profileId}
            initialData={editData}
            onSuccess={() => {
              setEditModalOpen(false);
              refetchCatalogues();
            }}
          />
        )}
      </CustomModal>
    </div>
  );
}
